<div class="form-nationality">
  <div class="sub-title" id="general-title"
    [innerHTML]="copyService.copies.form_nationality.title">
  </div>
  <form class="form row" [formGroup]="formGroup">
    <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <voxel-form-field id="countrySelectionLabel" [label]="copyService.copies.form_nationality.country" class="form-field-font vertical-margin">
        <vcl-autocomplete class="autocomplete-font" [id]="'input-value-country'" [placeholder]="copyService.copies.form_nationality.placeHolder" (change)="selectOption($event)" required 
              [notFoundTitle]="copyService.copies.form_nationality.filter_not_found_title" 
              [notFoundMessage]="copyService.copies.form_nationality.filter_not_found_message">
              <vcl-option [id]="'countrySelection' + option.country_code" *ngFor="let option of options" [value]="option" [selected]="option.country_code === selectedCountry.country_code">
            {{ option.description }}
          </vcl-option>
        </vcl-autocomplete>
      </voxel-form-field>
    </div>
    <div class="field col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
      <vcl-form-field label="{{ copyService.copies.form_nationality.identNumber }}"
        msgErr="{{ copyService.copies.form_nationality.errorMens }}">
        <input vclInput id="inputValueIdentNumber" maxlength="15" type="text"
          (change)="reactiveInputChangeAddress()" formControlName="input-value-identNumber">
      </vcl-form-field>
    </div>
  </form>
</div>
<app-controls id="formNationalityBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.form_nationality.btnNext"
  [nextDisabled]="!formGroup.valid || !selectedCountry.country_code" (next)="next()"></app-controls>